'use client'

import { TermsSkeleton } from './terms-skeleton'

type Props = {
  terms: string | ''
}

export function Terms({ terms }: Props) {
  return (
    <div className='relative mt-6 mb-4 flex justify-between py-5 text-lg'>
      {terms ? (
        <div dangerouslySetInnerHTML={{ __html: terms }} />
      ) : (
        <TermsSkeleton />
      )}
    </div>
  )
}
